export const getBeneficiaryEntityValue = beneficiary => {
  return Object.values(beneficiary)[0];
};
